import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { AlertaPerfilRiesgo } from '../_models/alerta-perfil-riesgo';

@Injectable({
  providedIn: 'root'
})
export class AlfrescoService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/alfresco';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  getUrl() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as any ) );
  }

  iniciar( regCrear: any ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as any ) );
  }

  detener( regActualizar: any ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

  getProgreso() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as any ) );
  }

}
